/**
 * Choosing and paying for a plan from the subscription screens: the same Billing page the admin has in
 * the dashboard (plans per student per term at this term's exchange rate, see services/pricingCore.ts).
 * The old flat monthly plans are retired.
 */
import React, { Suspense, lazy } from 'react';
import { useSchool } from '../contexts/SchoolContext';
import { Spinner } from './common/UIComponents';

const BillingPage = lazy(() => import('./billing/BillingPage'));

interface Props {
  open: boolean;
  onClose: () => void;
}

export const SubscriptionPlansModal: React.FC<Props> = ({ open, onClose }) => {
  const { currentSchool } = useSchool();
  if (!open || !currentSchool) return null;
  return (
    <div className="fixed inset-0 z-[300] overflow-y-auto bg-black/80 p-4" onClick={onClose}>
      <div className="relative mx-auto max-w-5xl rounded-3xl bg-slate-50 p-4 dark:bg-slate-900 md:p-6" onClick={e => e.stopPropagation()}>
        <button onClick={onClose} className="absolute right-4 top-4 z-10 rounded-full bg-white/80 px-3 py-1 text-sm font-bold text-slate-700 dark:bg-slate-800 dark:text-slate-200">Close</button>
        <Suspense fallback={<div className="flex h-64 items-center justify-center"><Spinner /></div>}>
          <BillingPage schoolId={currentSchool.id} />
        </Suspense>
      </div>
    </div>
  );
};

export default SubscriptionPlansModal;
